import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { EditIcon } from '@sketchnote/icons';
import {
  ELEMENT_LINK,
  getAboveNode,
  isCollapsed,
  PlateRenderElementProps,
  unwrapNodes,
  upsertLink,
  useEditorState,
  Value,
} from '@udecode/plate';
import * as React from 'react';

const { useCallback } = React;

type ElementProps<TElement = { element: { url: string } }> = PlateRenderElementProps<Value> &
  TElement;

export const LinkElement = ({ attributes, children, element }: ElementProps): JSX.Element => {
  const editor = useEditorState();

  const handleMouseDown = useCallback((event) => {
    event.preventDefault();
    let prevUrl = '';

    const linkNode = getAboveNode(editor, {
      match: { type: ELEMENT_LINK },
    });
    if (linkNode) {
      prevUrl = linkNode[0].url as string;
    }
    const url = window.prompt(`Enter the URL of the link:`, prevUrl);
    if (!url) {
      linkNode &&
        editor.selection &&
        unwrapNodes(editor, {
          at: editor.selection,
          match: { type: ELEMENT_LINK },
        });

      return;
    }

    // If our cursor is in middle of a link, then we don't want to inser it inline
    const shouldWrap: boolean = linkNode !== undefined && isCollapsed(editor.selection);
    // insertTextInLink needs to be tested
    upsertLink(editor, { url, insertTextInLink: shouldWrap });
  }, []);
  return (
    <Popover placement="bottom" trigger="click">
      <PopoverTrigger>
        <a {...attributes} href={element.url} className="text-primary-500 underline">
          {children}
        </a>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <div className="shadow-xl items-center rounded-lg flex px-16 py-18 bg-white justify-between">
            <a
              className="text-gray-999 underline max-w-266 overflow-hidden link-title"
              target="_blank"
              href={element.url}
              rel="noreferrer"
            >
              {element.url}
            </a>
            <button className="ml-10 text-gray-500 flex" onMouseDown={handleMouseDown}>
              <EditIcon />
            </button>
          </div>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
